<script>
import { montaAnosSelectDib, right } from '@/service/util'

import vSelect from 'vue-select'

export default {
  data () {
    return {
      mes: null,
      ano: null,
      meses: [{ value: 1, label: 'Janeiro', dias: 31 },
        { value: 2, label: 'Fevereiro', dias: 28 },
        { value: 3, label: 'Março', dias: 31 },
        { value: 4, label: 'Abril', dias: 30 },
        { value: 5, label: 'Maio', dias: 31 },
        { value: 6, label: 'Junho', dias: 30 },
        { value: 7, label: 'Julho', dias: 31 },
        { value: 8, label: 'Agosto', dias: 31 },
        { value: 9, label: 'Setembro', dias: 30 },
        { value: 10, label: 'Outubro', dias: 31 },
        { value: 11, label: 'Novembro', dias: 30 },
        { value: 12, label: 'Dezembro', dias: 31 }],
      anos: [],
      optionsFilter: []
    }
  },
  components: { vSelect },
  props: {
    value: {
      type: [String, Object],
      default: null,
      required: false
    },
    retroceder: {
      type: Number,
      default: 10,
      required: false
    },
    tipo: {
      type: String,
      default: 'inicial',
      required: false
    }
  },
  methods: {
    montaEmitDIB: function () {
      if (this.mes && this.ano) {
        if (this.tipo === 'final') this.$emit('model', right('0' + this.mes.value, 2) + '-' + this.mes.dias + '-' + this.ano.value)
        else this.$emit('model', right('0' + this.mes.value, 2) + '-' + '01-' + this.ano.value)
      } else this.$emit('model', '')
    }
  },
  watch: {
    mes: function () { this.montaEmitDIB() },
    ano: function () { this.montaEmitDIB() },
    value: function (value, oldValue) {
      if (!value && (value !== oldValue)) this.mes = this.ano = null
    }
  },
  mounted () {
    this.anos = montaAnosSelectDib(this.retroceder)
    if (this.value) {
      let value = this.value.split('-')
      this.mes = this.meses[(value[1] - 1)]
      this.ano = {label: value[0], value: value[0]}
    }
  }
}
</script>
<template>
  <div class="row">
    <div class="col-lg-7">
      <v-select v-model="mes" :options="meses" placeholder="Mês" :filterable="true"></v-select>
    </div>
    <div class="col-lg-5">
      <v-select v-model="ano" :options="anos" placeholder="Ano" :filterable="true"></v-select>
    </div>
  </div>
</template>

<style scoped>
  .col-lg-7 {
    padding-right: 3px;
  }
  .col-lg-5 {
    padding-left: 3px;
  }
</style>



// WEBPACK FOOTER //
// select-dib.vue?039aae8d